export const MY_CALENDAR_CONSTANTS = {
  EDIT: "EDIT",
  DELETE: "DELETE",
  ASSIGNMENT: "ASSIGNMENT",
  COURSE: "COURSE",
  CALENDAR_EVENT_ITEM: "CALENDAR_EVENT_ITEM",
  SCHOOL_CALENDAR_EVENT: "SCHOOL_CALENDAR_EVENT",
  PROJECT_DEADLINE_EVENT: "PROJECT_DEADLINE",
  ALL: "ALL",
  SCHOOL_CALENDAR_EVENT_TAGS: "SCHOOL_CALENDAR_EVENT_TAGS",
  CLASS_TAGS: "CLASS_TAGS",
  ALL_DAY_EVENT: "ALL_DAY_EVENT",
  TIME_BASED_EVENT: "TIME_BASED_EVENT",
  MYP_PROJECT_DEADLINE: "MYP_PROJECT_DEADLINE",
  MYP_PROJECT_DEADLINE_NEW: "MYP_PROJECT_DEADLINE_NEW",
  DP_PROJECT_DEADLINE: "DP_PROJECT_DEADLINE",
  CREATE_EVENT: "CREATE_EVENT",
  CREATE_MYP_PROJECT_DEADLINE: "CREATE_MYP_PROJECT_DEADLINE",
  CREATE_DP_DEADLINE: "CREATE_DP_DEADLINE",
  CREATE_DP_DEADLINE_NEW: "CREATE_DP_DEADLINE_NEW",
  DUE_DATE: "DUE_DATE",
  MONTH: "month",
  LIST: "list",
  WEEK: "week",
  PERSONAL: "PERSONAL",
  COMMUNITY: "COMMUNITY",
  DAILY_VIEW_CALENDAR: "DailyViewCalendar",
  FULLSCREEN_VIEW_CALENDAR: "FullScreenViewCalendar",
  SCHOOL_CALENDAR: "SCHOOL_CALENDAR",
  DP_TOK_ESSAY: "DP_TOK_ESSAY",
  DP_TOK_EXHIBITION: "DP_TOK_EXHIBITION",
  DP_EE: "DP_EE",
  DP_G4_PROJECT: "DP_G4_PROJECT",
  DP_COLLABORATIVE_SCIENCES_PROJECT: "DP_COLLABORATIVE_SCIENCES_PROJECT",
  ASSESSMENT: "ASSESSMENT",
  RECURRING_MEETING: "RECURRING_MEETING",
  INTERNAL_EXTERNAL_ASSESSMENT: "INTERNAL_EXTERNAL_ASSESSMENT",
  YOUR_CLASSES: "your_classes",
  OTHER_CLASSES: "other_classes",
  ALL_CLASSES: "all_classes",
  VIDEO_MEETING: "VIDEO_MEETING",
  VIEW_ONLY_TAGS: "VIEW_ONLY_TAGS",
  DP_CALENDARS: "DP_CALENDARS",
  MYP_CALENDARS: "MYP_CALENDARS",
  CLASS_CALENDARS: "CLASS_CALENDARS",
  DAILY_VIEW: "DAILY_VIEW",
  HOLIDAYS_EXCEPTION: "HOLIDAYS_EXCEPTION",
  CP_REFLECTIVE_PROJECT: "CP_REFLECTIVE_PROJECT",
  CREATE_DP_CP_DEADLINE: "CREATE_DP_CP_DEADLINE",
  AGENDA: "agenda",
  CREATE_DP_CP_DEADLINE_NEW: "CREATE_DP_CP_DEADLINE_NEW",
};
